import ExtendableError from 'es6-error'

export class SportsbookError extends ExtendableError {
  constructor (msg, res) {
    super(msg)
    this.name = 'SportsbookError'
    this.message = msg
    this.res = res
  }
}

export class RacingError extends ExtendableError {
  constructor (msg, res) {
    super(msg)
    this.name = 'RacingError'
    this.message = msg
    this.res = res
  }
}

export class BetslipError extends ExtendableError {
  constructor (code, violationInfo) {
    super(code)
    this.code = code
    this.violationInfo = violationInfo
    this.name = 'BetslipError'
  }
}

export const BETSLIP_ERROR_CODE = {
  /*
    Betslip validation response code on bet validation failed
    Bet validation error provided bet errors by request ids
    Contains violations field for multiple errors per bet
  */
  BET_VALIDATION_FAILED: 'BET_VALIDATION_FAILED',
  OUTCOME_INACTIVE: 'OUTCOME_INACTIVE',
  MAX_BET_AMOUNT_EXCEEDED: 'MAX_BET_AMOUNT_EXCEEDED',
  MIN_BET_AMOUNT_EXCEEDED: 'MIN_BET_AMOUNT_EXCEEDED',
  NOT_VALID_AMOUNT: 'NOT_VALID_AMOUNT'
}

export const BETSLIP_VIOLATION = {
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  /*
    Used in quickbet when adding bets without amount
  */
  BET_AMOUNT_REQUIRED: 'BET_AMOUNT_REQUIRED',

  /*
    Used in bet validations and based on betslip.settings
  */
  MAX_ODDS_AMOUNT_EXCEEDED: 'MAX_ODDS_AMOUNT_EXCEEDED',
  MAX_OUTCOMES_SIZE_EXCEEDED: 'MAX_OUTCOMES_SIZE_EXCEEDED',

  /*
    Used when complex bet contains outcome that available for singles only
    If event.onlySingle = true
  */
  SINGLE_BET_ONLY: 'SINGLE_BET_ONLY',
  OUTCOME_ODDS_CHANGED: 'OUTCOME_ODDS_CHANGED'
}

/*
  Examples
*/

/*
  Betslip place bet error:
  {
    "timestamp": 1602590185956,
    "status": 400,
    "error": "Bad Request",
    "message": "Validation failed for object='placeBetRequest'. Error count: 1",
    "errors": [
      {
        "codes": [
          "NotEmpty.placeBetRequest.bets[0].outcomes",
          "NotEmpty.placeBetRequest.bets.outcomes",
          "NotEmpty.bets[0].outcomes",
          "NotEmpty.bets.outcomes",
          "NotEmpty.outcomes",
          "NotEmpty.java.util.List",
          "NotEmpty"
        ],
        "arguments": [
          {
            "codes": [
              "placeBetRequest.bets[0].outcomes",
              "bets[0].outcomes"
            ],
            "arguments": null,
            "defaultMessage": "bets[0].outcomes",
            "code": "bets[0].outcomes"
          }
        ],
        "defaultMessage": "must not be empty",
        "objectName": "placeBetRequest",
        "field": "bets[0].outcomes",
        "rejectedValue": null,
        "bindingFailure": false,
        "code": "NotEmpty"
      }
    ],
    "path": "/bettor/sport/bet:validate",
    "traceId": "b9940dfc1a901541"
  }
*/

/*
  Betslip place bet validation error:
  {
    "timestamp": 1602600824992,
    "status": "PRECONDITION_FAILED",
    "message": "Bet validation failed",
    "code": "BET_VALIDATION_FAILED",
    "errors": [
      {
        "requestId": 136165,
        "betDto": {
          "betId": null,
          "clientId": 3,
          "requestId": 136165,
          "betType": "MULTIPLE",
          "acceptOddsChanges": "YES",
          "acceptParameterChanges": null,
          "bonusInfoList": [],
          "odds": 2900.205,
          "betOdds": 2900.205,
          "oddsLimit": null,
          "betStatus": "UNSETTLED",
          "betMoney": {
            "currency": "USD",
          },
          ...
        },
        "violations": [
          {
            "code": "MAX_ODDS_AMOUNT_EXCEEDED",
            "message": "Bet odds - [2900.2050000] exceeds max limit - [800]",
            "violationInfo": {
              "maxOdds": 800
            }
          }
        ]
      }
    ]
  }
*/

/*
  Betslip edit bet error:
  {
    "timestamp": 1603373476586,
    "status": 412,
    "message": "CashOut amount changed",
    "code": "CASH_OUT_AMOUNT_CHANGED",
    "additionalInfo": {
      "newCashOutAmount": 490
    }
  }
*/
